import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Assignment } from '@material-ui/icons';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import { currency } from 'hooks/Pipe';

const stylesCard = {
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};

const useStyles = makeStyles(stylesCard);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'Fecha', accessor: 'date_migrate', width: 100 },
  { Header: 'Estado', accessor: 'state_migrate', width: 100 },
  { Header: 'Zona', accessor: 'sede', width: 200 },
  { Header: 'Vendedor', accessor: 'seller' },
  { Header: 'Térm. pago', accessor: 'PymntGroup', width: 130 },
  { Header: 'Pedido', accessor: 'order', width: 100 },
  { Header: 'Saldo', accessor: 'saldo', width: 100 },
  { Header: 'Importe', accessor: 'total_order', width: 120 },
  { Header: 'Margen', accessor: 'margen', width: 120 },
  { Header: 'Descuento', accessor: 'discount', width: 120 },
  { Header: 'Observación', accessor: 'observation', width: 200 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function OrderSap(props) {
  const classes = useStyles();
  const { businessPartner } = props;

  const [orders, setOrders] = useState([]);

  async function listOrders() {
    let response = await wsFindBy('sale/order', {
      /* state_migrate: "x", */
      base_business_partner_id: businessPartner.id
    });
    if (response.success) setOrders(response.data);
  }

  useEffect(() => {
    listOrders();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color={props.themeContext.buttonColor}>
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Listado de pedidos SAP</h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          formatDate="YYYY-MM-DD"
          excelName={'Pedidos-SAP-' + businessPartner.CardCode}
          defaultWidth={1800}
          columns={columns}
          data={orders.map((order, i) => {
            return {
              num: i + 1,
              id: order.id.toString(),
              date: order.date_migrate,
              state_migrate: order.state_migrate,
              sede: `${order.base_zone_code} - ${order.base_zone_description}`, //
              seller: `${order.SlpCode} - ${order.SlpName}`, //
              PymntGroup: order.PymntGroup, //
              order: order.order, //
              saldo: currency(order.saldo), //
              total_order: currency(order.total_order),
              margen: order.margin_amount, // otro dato
              discount: order.discount,
              observation: order.comments,
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
